<template>
  <div class="counter-controller">
    <div class="counter-title">
      <img src="../assets/tool-logo.png" alt="counter">
    </div>
    <div class="counter-label-input">
      <label for="counterLabel">ラベルテキスト</label><br>
      <input id="counterLabel" v-model="label" @input="updateLabel" type="text" placeholder="ラベルを入力">
    </div>
    <div class="counter-buttons">
      <button class="counter-button" @click="increment">+</button>
      <button class="counter-button" @click="decrement">-</button>
    </div>
    <p class="counter-count">{{ count }}</p>
    <button class="counter-button counter-reset-button" @click="reset">リセット</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      count: parseInt(localStorage.getItem('count') || '0'),
      label: localStorage.getItem('label') || ''
    };
  },
  methods: {
    increment() {
      this.count++;
      this.updateCounterDesign();
    },
    decrement() {
      this.count--;
      this.updateCounterDesign();
    },
    reset() {
      this.count = 0;
      this.updateCounterDesign();
    },
    updateCounterDesign() {
      localStorage.setItem('count', this.count.toString());
      console.log('カウントを更新しました:', this.count);
    },
    updateLabel() {
      localStorage.setItem('label', this.label);
      console.log('ラベルを更新しました:', this.label);
    },
    handleStorageChange(event) {
      if (event.key === 'count') {
        this.count = parseInt(event.newValue || '0');
      } else if (event.key === 'label') {
        this.label = event.newValue || '';
      }
    }
  },
  mounted() {
    window.addEventListener('storage', this.handleStorageChange);
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.handleStorageChange);
  },
}
</script>

<style>
.counter-title {
  display: flex;
  justify-content: center;
  align-items: center;
}

.counter-title img {
  width: 200px;
}

.counter-controller {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background-color: #FFBAC3;
  height: 100vh;
}
.counter-buttons {
  display: flex;
  gap: 10px;
}
.counter-button {
  padding: 10px;
  font-size: 1.5rem;
  background-color: #4c5c8a;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  border-radius: 10px;
}

.counter-button:hover {
  background-color: #3b4b74;
}
.counter-reset-button {
  background-color: #d9534f;
  font-size: 0.8rem;
  margin-top: 18px;
}
.counter-reset-button:hover {
  background-color: #c9302c;
}
.counter-count {
  font-size: 1.2rem;
}

.counter-label-input {
  margin-top: 0px;
  margin-bottom: 15px;
}
.counter-label-input label {
  font-size: 1rem;
}
.counter-label-input input {
  margin-top: 10px;
  padding: 5px;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid #ccc;
}
</style>